import { useState } from "react";
import { faqs } from "@/mocks/site";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="border-t border-background-200 bg-background-100/50 py-14 md:py-20">
      <div className="container-site grid gap-8 lg:grid-cols-[1fr_1.6fr] lg:gap-12">
        <div>
          <p className="mb-1 flex items-center gap-2 text-sm font-medium text-secondary-700">
            <i className="ri-question-answer-fill"></i> 常见问题
          </p>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            围观之前，
            <br />
            先看看这里
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            关于平台怎么用、后续怎么跟、评论区守则……都在下面说清楚了。还没覆盖到的，欢迎到页脚留言告诉我们。
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((f, idx) => {
            const isOpen = openIdx === idx;
            return (
              <div
                key={f.question}
                className={`overflow-hidden rounded-2xl border transition-colors ${
                  isOpen ? "border-primary-300 bg-background-50" : "border-background-200 bg-background-100/60"
                }`}
              >
                <button
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                  onClick={() => setOpenIdx(isOpen ? -1 : idx)}
                  aria-expanded={isOpen}
                >
                  <h3 className="font-heading text-base font-bold text-foreground-900 md:text-lg">{f.question}</h3>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                      isOpen ? "bg-primary-500 text-background-50" : "bg-secondary-200 text-secondary-700"
                    }`}
                  >
                    <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-lg`}></i>
                  </span>
                </button>
                {isOpen && (
                  <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{f.answer}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}